// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U3d6","label":"styles_label__3IdZq"};